import { Map as ImmutableMap } from 'immutable';
import data from '../static/languages.json';

/*
 * Language data comes in in a format that is somewhat easier to look at and edit by hand. It needs to be transformed
 * into a format that is easy to use in code.
 * Coming out, result object will look something like this:
 * {
 *   "en-XX": {
 *     "name": "English",
 *     "defaultLocale": "en-US"
 *     "locales": {
 *         "en-US": "English - USA",
 *         "en-GB": "English - UK"
 *         //etc
 *     }
 *   },
 *   "vi-VN": {
 *     "name": "Vietnamese"
 *   }
 *   //etc
 * }
 */
const buildLocales = () => {
  const result = new Map();

  for (const languageCode of Object.keys(data.languageCodes)) {
    const languageCodeData = data.languageCodes[languageCode];
    const languageCountries = languageCodeData.countries;

    // Skipping languages w/o countries b/c RTS doesn't support them now.
    // Some languages don't have a specific country, like Yiddish, for example.
    if ((!languageCountries || languageCountries.length === 0) && !languageCodeData.specialLocales) {
      continue;
    }
    if (languageCountries.length === 1 && !languageCodeData.specialLocales) {
      const code = languageCode + '-' + languageCodeData.countries[0];
      const name = languageCodeData.name + ' - ' + data.countryCodes[languageCodeData.countries[0]];
      result.set(code, {
        name: name,
      });
    } else {
      const code = languageCode + '-XX';
      const name = languageCodeData.name;

      const locales = new Map();
      // Later, when RTS supports pure language codes, can add this option:
      // locales[key] = value.name + ' (Language Code Only)';

      for (const country of languageCountries) {
        const specificCode = languageCode + '-' + country;
        const specificName = name + ' - ' + data.countryCodes[country];
        locales.set(specificCode, specificName);
      }

      if (languageCodeData.specialLocales) {
        for (const specialLocale of Object.keys(languageCodeData.specialLocales)) {
          locales.set(specialLocale, languageCodeData.specialLocales[specialLocale]);
        }
      }

      result.set(code, {
        name: name,
        locales: new ImmutableMap(locales),
        defaultLocale: languageCodeData.defaultLocale,
      });
    }
  }

  return new ImmutableMap(result).sortBy((v, k) => k);
};

export const locales = Object.freeze(buildLocales());
